import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import Layout from "@/components/Layout";
import TimerPage from "@/pages/TimerPage";
import ReportsPage from "@/pages/ReportsPage";
import TeamCalendarPage from "@/pages/TeamCalendarPage";
import ClientsPage from "@/pages/ClientsPage";
import ActivitiesPage from "@/pages/ActivitiesPage";
import TagsPage from "@/pages/TagsPage";
import MembersPage from "@/pages/MembersPage";
import OrganisationsPage from "@/pages/OrganisationsPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import PreferencesPage from "@/pages/PreferencesPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/set-password" element={<SetPasswordPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/timer" replace />} />
            <Route path="/timer" element={<TimerPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/team-calendar" element={<TeamCalendarPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/activities" element={<ActivitiesPage />} />
            <Route path="/tags" element={<TagsPage />} />
            <Route path="/members" element={<MembersPage />} />
            <Route path="/organisations" element={<OrganisationsPage />} />
            <Route path="/preferences" element={<PreferencesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/timer" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        duration={2000}
        closeButton
        toastOptions={{
          classNames: {
            toast: "shadow-md",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
